// extracted by mini-css-extract-plugin
export default {"icon":"I95_RFXT6tEIIOoM7I_4","footer":"NYhUD7n1px_X8rXJLYSu"};